module.exports = __webpack_public_path__ + "img/ring_0_0_null_1.18c70830.png";